<div
  class="grid grid-cols-6 p-4 gap-5 relative group bg-white"
  [ngClass]="{
    ' rounded-b-[12px]': isRoundedBottom(),
    ' rounded-t-[12px]': isRoundedTop(),
    ' p-4': !padding()
  }"
  [ngStyle]="{ padding: padding() + 'px' }"
>
  <div
    class="absolute top-3 right-3 bg-secondary-body items-center justify-center"
    [ngClass]="{
      'cursor-pointer group-hover:flex': isRemovable(),
      'cursor-default hidden': !isRemovable()
    }"
  >
    <ng-content select="[removeItem]"></ng-content>
  </div>
  @if(image || doHaveImage()){
  <div class="relative w-min max-w-min">
    <div class="w-14 h-14 rounded-[10px] bg-secondary-borders">
      <img
        [src]="image | placeholder"
        class="w-full h-full rounded-[10px] object-cover object-center"
        alt=""
      />
    </div>
    @if(isActive()){
    <div
      class="w-3 h-3 rounded-full bg-green-80 absolute -top-1 -right-1"
    ></div>
    }
  </div>
  }

  <div
    class="flex justify-between w-full"
    [ngClass]="{
      'col-span-full': !(image || doHaveImage()),
      'col-span-5': image || doHaveImage()
    }"
  >
    <div class="flex max-w-full flex-col justify-center font-medium">
      <h3><ng-content select="[title]"></ng-content></h3>
      <p class="text-secondary-base">
        <ng-content select="[description]"></ng-content>
      </p>
      <ng-content select="[additionalInfo]"></ng-content>
    </div>
    <div class="flex gap-4">
      <ng-content select="[rigthContent]"></ng-content>
      <ng-content></ng-content>
    </div>
  </div>
</div>
